import React, { useState } from 'react'
import { Box, Typography, Button } from '@mui/material';
import PrimaryButton from '../../../components/Button/Button';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import moment from 'moment';
import * as XLSX from "xlsx";
import { useClient } from '../../../reactQuery/client';
import { useLeadCompliance } from '../../../reactQuery/leadCompliance';

function SpreadsheetAnnualNotice() {
    const [loading,setLoading]= useState(false);

    const {
       isLoading,
       error,
       responseData,
       isError,
       refetch,
       totalRecords,
       isRefetching,
    } = useClient({
       pagination: false,
    });

      const currentYear = new Date().getFullYear();
      const prepareQueryFilters = `?year=${currentYear}&status=pending&pagination=false`;

      const {
        responseData: leadComplianceData, 
      } = useLeadCompliance(prepareQueryFilters, "SpreadsheetAnnualNotice");

    const createExcelObject = () => {
      const exportObject = leadComplianceData?.map((el) => {
        const client = responseData?.find(
          (item) => item.client_id === el.client_id
        );
        return {
          Client: el.client,
          Email: client?.user?.email,
          Phone_Number: client?.user?.phone_number,
          Building_address: el.building_address,
          Apartment: el.unit_number,
          City: client?.city,
          State: client?.state,
          Zip_Code: client?.zip_code,
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(exportObject); // Convert JSON data to worksheet
      const workbook = XLSX.utils.book_new(); // Create a new workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1"); // Append the worksheet
      XLSX.writeFile(workbook, `Outstanding-Annual-Notices.xlsx`); // Export the workbook to an Excel file

      setLoading(false);
    };

    const handleExcelReport = () => {
        setLoading(true);
        createExcelObject();
    }
  return (
    <Box className="report-card-content">
      <Typography variant="body2" className="report-description">
        Download a spreadsheet with mailing addresses of all units, across all
        buildings and clients, that have outstanding annual notices.
      </Typography>
      <Box className="report-action">
        <PrimaryButton
          className="capitalize primary-btn-class"
          variant="contained"
          onClick={handleExcelReport}
          startIcon={<FileDownloadOutlinedIcon />}
          disabled={loading}
        >
          Excel Report
        </PrimaryButton>
      </Box>
    </Box>
  );
}

export default SpreadsheetAnnualNotice